import { BetTypeEnum } from "./enums/betType";

export const racingForecastTypes = [
	BetTypeEnum.StraightForecast,
	BetTypeEnum.ReverseForecast,
	BetTypeEnum.CombinationForecast,
];

export const racingTricastTypes = [BetTypeEnum.StraightTricast, BetTypeEnum.CombinationTricast];

export const racingTypesList = racingForecastTypes.concat(racingTricastTypes);
